import { render, staticRenderFns } from "./Notification-settings.vue?vue&type=template&id=4cb22aad&scoped=true"
import script from "./Notification-settings.vue?vue&type=script&lang=js"
export * from "./Notification-settings.vue?vue&type=script&lang=js"
import style0 from "./Notification-settings.vue?vue&type=style&index=0&id=4cb22aad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb22aad",
  null
  
)

export default component.exports